export default {
  'SET_OBJECTS'(state, data) {
    state.objects = data;
    state.serialized = JSON.stringify(data);
  },
  'SET_OBJECT_TYPES'(state, data) {
    state.objectTypes = data;
  },
  'ADD_OBJECT'(state, data) {
    state.objects[data['id']] = data;
    state.serialized = JSON.stringify(state.objects);
  },
  'DELETE_OBJECT'(state, id) {
    delete state.objects[id];
    state.serialized = JSON.stringify(state.objects);
  },
  'SET_COMBINE_FUNCTIONS'(state, data) {
    state.combineFunctions = data;
  },
  'SET_ADJUSTMENT_FUNCTIONS'(state, data) {
    const dataToSet = [...data];
    dataToSet.unshift({"name": "none"});
    state.adjustmentFunctions = dataToSet;
  },
  'REPLACE_OBJECT'(state, obj) {
    state.objects[obj['id']] = obj;
  },
  'SET_GROUPS'(state, data) {
    state.groups = data;
  },
  'REPLACE_GROUP'(state, payload) {
    state.groups = state.groups.map(item => {
      if (parseInt(item['id']) === parseInt(payload.id)) {
        return payload;
      }

      return item;
    });
  },
  'REMOVE_GROUP'(state, id) {
    state.groups = state.groups.filter(item => {
      return parseInt(item.id) !== parseInt(id);
    });
  },
  'ADD_GROUP'(state, payload) {
    state.groups.push(payload);
  },
  'SET_BOARDS'(state, payload) {
    state.boards = payload;
  },
  'ADD_BOARD'(state, payload) {
    state.boards.push(payload);
  },
  'REPLACE_BOARD'(state, payload) {
    state.boards = state.boards.map(item => {
      if (parseInt(item['id']) === parseInt(payload.id)) {
        return payload;
      }

      return item;
    });
  },
  'REMOVE_BOARD'(state, id) {
    state.boards = state.boards.filter(item => {
      return parseInt(item.id) !== parseInt(id);
    });
  }
};